import { render, staticRenderFns } from "./ApproveFooter.pug?vue&type=template&id=b8286f3e&scoped=true&lang=pug&"
import script from "./ApproveFooter.vue?vue&type=script&lang=js&"
export * from "./ApproveFooter.vue?vue&type=script&lang=js&"
import style0 from "./ApproveFooter.scss?vue&type=style&index=0&id=b8286f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8286f3e",
  null
  
)

export default component.exports